var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicHeartsBroken = function SvgGraphicHeartsBroken(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "2in",
    viewBox: "0 0 216 144",
    width: "3in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 224,
    cy: 135.18,
    gradientUnits: "userSpaceOnUse",
    r: 102.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -33.16,
    cy: 130.43,
    gradientUnits: "userSpaceOnUse",
    r: 150.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 129.21,
    cy: 117.26,
    gradientTransform: "matrix(1 0 0 .7 0 35.37)",
    gradientUnits: "userSpaceOnUse",
    r: 112.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 67.44,
    x2: 126.91,
    y1: 85.38,
    y2: 25.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c689ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d74cf0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 37.24,
    x2: 138.18,
    y1: 121.61,
    y2: 20.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b833e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ff4f5e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 80.06,
    x2: 199.29,
    y1: 149.59,
    y2: 30.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7542e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#824deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a067fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab71ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m209.32 76.55a9.51 9.51 0 0 1 -9.47 9.51h-38.07a7.27 7.27 0 0 1 0-14.54 7.15 7.15 0 0 1 1.74.22 7.89 7.89 0 0 1 -.2-1.69 7.5 7.5 0 0 1 11.74-6.18 12.6 12.6 0 0 1 24.79 3.13 9.51 9.51 0 0 1 9.47 9.55z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84.66 32.38a10.74 10.74 0 0 0 -2.66.32 11.09 11.09 0 0 0 .29-2.53 11.3 11.3 0 0 0 -17.69-9.31 19 19 0 0 0 -37.37 4.77 14.27 14.27 0 1 0 0 28.54h57.43a10.9 10.9 0 0 0 0-21.79z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.87 72.66a22.54 22.54 0 0 1 22.45-22.66l120.77-.48a22.53 22.53 0 1 1 .18 45.06l-120.77.53a22.54 22.54 0 0 1 -22.63-22.45z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m83.89 81.48h29.85v8.65h-29.85z",
    fill: "#ff848b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m61.36 31.98h71.63v47.31h-71.63z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m140.78 84.07h-1.95v-53.76a3.86 3.86 0 0 0 -3.83-3.86h-75.54a3.86 3.86 0 0 0 -3.86 3.87v53.75h-2a1.92 1.92 0 0 0 -1.88 1.93v3.9a1.92 1.92 0 0 0 1.93 1.93h87.13a1.93 1.93 0 0 0 1.93-1.93v-3.9a1.93 1.93 0 0 0 -1.93-1.93zm-35.78 3.87h-15.53v-3.87h15.53z",
    fill: "url(#e)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#f)",
    height: 62.76,
    rx: 5.4,
    width: 41.61,
    x: 122.66,
    y: 54.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m139.53 107.32h7.75v3.87h-7.75z",
    fill: "#ab71ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m107.19 47.81a6.25 6.25 0 0 0 -8.81 0l-.17.18-1.31 3.2 5.23.32a1 1 0 0 1 .63 1.62l-6.12 6.34a1 1 0 0 1 -.69.29.93.93 0 0 1 -.66-.27 1 1 0 0 1 0-1.36l4.68-4.83-4.52-.3a1 1 0 0 1 -.76-.45 1 1 0 0 1 -.07-.87l1.49-3.68-.24-.23a6.23 6.23 0 0 0 -8.8 0 6.22 6.22 0 0 0 0 8.8l9 9a1.5 1.5 0 0 0 1.07.44 1.54 1.54 0 0 0 1.07-.44l9-9a6.24 6.24 0 0 0 -.02-8.76zm46.2 26.3a6.24 6.24 0 0 0 -8.81 0l-.18.18-1.3 3.21 5.23.32a1 1 0 0 1 .63 1.62l-6.12 6.33a1 1 0 0 1 -1.35 0 1 1 0 0 1 0-1.35l4.68-4.83-4.49-.28a1 1 0 0 1 -.76-.44 1 1 0 0 1 -.07-.87l1.49-3.67-.24-.24a6.23 6.23 0 0 0 -8.8 8.81l9 9a1.51 1.51 0 0 0 2.15 0l9-9a6.25 6.25 0 0 0 -.06-8.79z",
    fill: "#f9f9fa"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicHeartsBroken);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_hearts_broken.3d3fe46e97c5451ed37dc5f1c2e8f88c.svg";